/**
 * "Who to watch just changed": a join approved on this phone, or a membership notification from
 * another. The running Find session re-reads lynx_event_peers at once instead of on its 45 s timer
 * (2026-10-14 Turnstile: the approver's Find saw the new member 45 s after the approval).
 */
type Listener = (reason: string) => void;

const listeners = new Set<Listener>();

export function requestFindPeersRefresh(reason: string): void {
  listeners.forEach((cb) => cb(reason));
}

export function onFindPeersRefreshRequest(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
